import React from 'react';
import { Label, CheckBox } from './styles';

interface Props {
  checked?: boolean;
  onChange?: (value: boolean) => void;
}

const Switch: React.FC<Props> = (props) => {
  const { checked, onChange } = props;

  const onClick = (): void => {
    onChange?.(!checked);
  };

  return (
    <Label>
      <CheckBox checked={checked} onClick={onClick} />
    </Label>
  );
};

export default Switch;
